module.exports = __webpack_public_path__ + "static/media/linux-mint.6e405996.png";